import { findLmsUnitByUnitId } from 'utils/program/k8CourseUnitHelpers'

export const findCourseName = () => {
  const regex = /grade-(k|[1-9])(?:\/|$)/
  const matches = location.pathname.match(regex)

  const courseName = matches && matches.length > 0 ? matches[1] : null

  // Return null if no match found
  if (!courseName) {
    return null
  }

  // Return null if the grade is not 1-9 or 'k'
  if (
    courseName !== 'k' &&
    (isNaN(courseName) || courseName < '1' || courseName > '9')
  ) {
    return null
  }

  // have to capitalize K to help with how it is stored in course manager
  if (courseName === 'k') {
    return 'K'
  }
  return courseName
}

export const findLmsUnit = ({ courseTrees, lmsClass, unitId }) => {
  const courseName = findCourseName()
  const courseTree = courseTrees[courseName]
  if (!courseTree) {
    return null
  }

  return findLmsUnitByUnitId({ lmsClass, courseTree, unitId })
}
